<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/h6VcX1/tc-custom/9781504065399.jpg?1709147586522" alt="This image is the cover for the book Common Reader, The Common Reader"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Common Reader, The Common Reader
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of essays from the acclaimed author of <i>Mrs. Dalloway</i> on such subjects as Jane Austen, Geoffrey Chaucer, and her own literary philosophy.</b><br/>  <br/><i>A good essay must have this permanent quality about it; it must draw its curtain round us, but it must be a curtain that shuts us in not out.</i><br/>  <br/> Not written for scholars or critics, these essays are a collection of Virginia Woolf’s everyday thoughts about literature and the world—and the art of reading for pleasure. That many of them previously appeared in such publications as <i>the</i><i> Nation</i>, <i>Vogue</i>, and the<i> Yale Review points to their widespread appeal.</i> Still, her brilliant powers of observation and insatiable curiosity shine through . . .<br/>  <br/> “After all, Mrs. Woolf is no common reader, try as she may to be one. Her powers of coordination and logical inference are altogether too strong and capable. No common reader would kick the over-praised <i>Robinson Crusoe</i> overboard to float in seas of adolescent adoration for <i>Moll Flanders</i>, as she does. It would take an uncommon common reader to discourse as pithily on Elizabethan drama or the furiously literary Duchess of Newcastle. No idle peruser of the printed page would meditate so beautifully on Greek letters. And when we come to those essays, ‘Modern Fiction’ and ‘How It Strikes a Contemporary,’ a note that is altogether professional and the result of intensive study and theorizing is to be discerned.” —<i>The New York Times</i><br/>  <br/> “Woolf’s provocative collection of essays, reviews and flights of literary imagination assesses both the famous and the obscure.” —<i>The Times </i>(London)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Virginia Woolf
      </h2>
      
      <p class="authorDescription body article"> Virginia Woolf (1882&ndash;1941), an English modernist, has been heralded as one of the greatest female writers of all time. In 1915, she published her first novel, <I>The Voyage Out</I>, which became known for its peculiar narrative perspectives and free-association prose. She followed this up with several famous novels such as <I>Mrs. Dalloway</I> and<I> Jacob&rsquo;s Room</I>, as well as the feminist essay <I>A Room of One&rsquo;s Own</I>. Woolf suffered from depression and committed suicide in 1941. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?137d9487